// extracted by mini-css-extract-plugin
module.exports = {"Organizations":"ktavl2Yyy4JUoFp_WIUZ"};